import { action, observable, makeObservable } from 'mobx';
import { isEmpty } from 'lodash';
import { searchService } from 'config/ioc';
import { FULFILLED, PENDING, REJECTED } from 'constants/actions';
import { handleSentryDataError } from '../utils/errors';

const DEFAULT_ERROR = {
  validationErrors: {},
  baseErrors: {},
};

class SearchStore {
  constructionsFetchState;

  customersFetchState;

  usersFetchState;

  teamsFetchState;

  officesFetchState;

  constructions = [];

  customers = [];

  users = [];

  teams = [];

  offices = [];

  errors = DEFAULT_ERROR;

  constructor() {
    makeObservable(this, {
      constructionsFetchState: observable,
      customersFetchState: observable,
      usersFetchState: observable,
      teamsFetchState: observable,
      officesFetchState: observable,
      constructions: observable.ref,
      customers: observable.ref,
      users: observable.ref,
      teams: observable.ref,
      offices: observable.ref,
      getConstructions: action.bound,
      getCustomers: action.bound,
      getUsers: action.bound,
      getTeams: action.bound,
      getOffices: action.bound,
      getOfficesByIds: action.bound,
    });
  }

  async getConstructions(params) {
    this.constructionsFetchState = PENDING;
    try {
      const response = await searchService.getConstructions(params);
      this.constructions = response.data.data.items;
      this.constructionsFetchState = FULFILLED;
    } catch (e) {
      this.constructionsFetchState = REJECTED;
    }
  }

  async getCustomers(params) {
    this.customersFetchState = PENDING;
    try {
      const response = await searchService.getCustomers(params);
      this.customers = response.data.data.items;
      this.customersFetchState = FULFILLED;
      return this.customers;
    } catch (e) {
      if (!e.errors) {
        this.errors = handleSentryDataError(e);
      }
      this.customersFetchState = REJECTED;
      return [];
    }
  }

  async getUsers(params) {
    this.usersFetchState = PENDING;
    try {
      const response = await searchService.getUsers(params);
      this.users = response.data.data.items;
      this.usersFetchState = FULFILLED;
      return this.users;
    } catch (e) {
      if (!e.errors) {
        this.errors = handleSentryDataError(e);
      }
      this.usersFetchState = REJECTED;
      return [];
    }
  }

  async getTeams(params) {
    this.teamsFetchState = PENDING;

    try {
      const response = await searchService.getTeams(params);
      this.teams = response.data.data.items;
      this.teamsFetchState = FULFILLED;
    } catch (e) {
      if (!e.errors) {
        this.errors = handleSentryDataError(e);
      }
      this.teamsFetchState = REJECTED;
    }
  }

  async getOffices() {
    if (!isEmpty(this.offices)) {
      return;
    }

    this.officesFetchState = PENDING;

    try {
      const response = await searchService.getOffices();
      this.offices = response.data.data.items;

      this.officesFetchState = FULFILLED;
    } catch (e) {
      if (!e.errors) {
        this.errors = handleSentryDataError(e);
      }
      this.officesFetchState = REJECTED;
    }
  }

  getOfficesByIds(ids) {
    if (!ids || ids.length === 0) return [];
    return this.offices.filter((item) => {
      return ids.includes(item.id);
    });
  }
}

const searchStore = new SearchStore();

export default searchStore;
